import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { ReputationAnalysisPageBg } from "@/components/site/ReputationAnalysisPageBg";

import { pageSchemas } from "@/lib/seo/page-schema";
export const Route = createFileRoute("/bg/media-analysis/reputation")({
  head: () => ({
    meta: [
      { title: "Анализ на репутацията | Perceptica" },
      {
        name: "description",
        content:
          "Анализът на репутацията от Perceptica показва как заинтересованите страни възприемат вашия бранд чрез анализ на тоналност, наративи, ключови фактори и стратегически препоръки.",
      },
      { property: "og:title", content: "Анализ на репутацията | Perceptica" },
      {
        property: "og:description",
        content:
          "Анализът на репутацията от Perceptica показва как заинтересованите страни възприемат вашия бранд чрез анализ на тоналност, наративи, ключови фактори и стратегически препоръки.",
      },

      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Анализ на репутацията | Perceptica" },
      { name: "twitter:description", content: "Анализът на репутацията от Perceptica показва как заинтересованите страни възприемат вашия бранд чрез анализ на тоналност, наративи, ключови фактори и стратегически препоръки." },
      { property: "og:url", content: "https://perceptica.com/bg/media-analysis/reputation" },
      ...ogImageMeta("bg", "/media-analysis/reputation"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/media-analysis/reputation", service: { name: "Анализ на репутацията", description: "Анализ на репутацията от Perceptica за Югоизточна Европа.", serviceType: "Анализ на репутацията" } }),
  }),
  component: ReputationAnalysisPageBg,
});
